import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../Context/InshData";
import { uri } from "../../../help/Api";
import HashLoader from "react-spinners/HashLoader";
import { colors, Container, Dialog, Modal } from "@material-ui/core";
import LoadingPage from "../../../services/LoadingPage";
import AnnualSuscription from "./AnnualSuscription";
const defaultAutos = {
  Branches: [],
};

export default function AnnualSuscriptionCon(props ) {
  const tb = {
    wait: true,
    other: true,
    Branch: true,
    GetFoundation:true,
    parms: {
      iempid: sto.empi,
      branch:sto.branchi,
      db_name: sto?.db_name
    },
    autos: {  },
  };


  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
  );

  if (
    fetchAll ||
    !AutoOptions?.Branches
  )
    return <LoadingPage />;

  return (

    <AnnualSuscription
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
      }}
    />
  );
}
